// $('.categories_list01').slick({
//   arrows: false,
//   dots: true,
//   infinite: true,
//   speed: 300,  
//   centerMode: true,
//   variableWidth: true
// });


// var swiper = new Swiper(".categories_list", {
//   slidesPerView: 5,
//   spaceBetween: 24,
//   scrollbar: {
//     draggable: true,
//     el: ".categories_section.swiper-scrollbar"
//   },
//   breakpoints: {
//     650: {
//       slidesPerView: 2,
//     },
//     1040: {
//       spaceBetween: 48,
//       slidesPerView: 5,
//     },
//   },
// });
window.onload = function() {
  $('.categories_list').slick({
    infinite: true,
    slidesToShow: 5,
    centerMode: true,
    arrows: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1301,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
};

$(document).ready(function () {
  const $slider = $('.js-product-card-images');
  // Destroy Slick if already initialized
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  // Apply CSS styles using jQuery
  $slider.find('.slide').css({
    padding: '10px',
    'box-sizing': 'border-box',
    'text-align': 'center'
  });
  $slider.find('.slide img').css({
    width: 'auto',
    height: 'auto',
    display: 'block',
    margin: '0 auto'
  });
  // Re-initialize Slick slider
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});


// Showing Alternative In-Stock Options
document.addEventListener("DOMContentLoaded", function () {
  const swatches        = document.querySelectorAll(".pdp_swatches");
  const showAlternate   = document.querySelector('.selected_notinstock');
  const variantDropdown = document.querySelector('.pdp_variant_selection');
  const preOrderNote    = document.querySelector('.pre_order_note');
  const ATCBtnText      = document.querySelector('.product-form__cart-submit .add_to_cart_text');
  const productNotes    = document.querySelector('.product_notes');

  if (!window.productVariants || !showAlternate) return;

  // Run on page load
  setTimeout(() => {
    pdpSwatchesCheckAvailablity();
    getSelectedVariantIdFromDropdown()
  }, 500);

  // Swatch Click
  swatches.forEach(swatch => {
    swatch.addEventListener("click", function () {
      const clickedVariantId = parseInt(this.dataset.vid);
      if (!clickedVariantId) return;
      checkVariantAvailability(clickedVariantId);
    });
  });

  // On change of dropdown variant select
  if (variantDropdown) {
    variantDropdown.addEventListener('change', function () {
      const selectedVariantId = getSelectedVariantIdFromDropdown();
      if (selectedVariantId) {
        checkVariantAvailability(selectedVariantId);
      }
    });
  }

  // PAGE LOAD CHECK
  function pdpSwatchesCheckAvailablity() {
    const checkedRadio = document.querySelector('.radio_option_selector:checked');
    if (!checkedRadio) return;
    const selectedVariantId = parseInt(checkedRadio.dataset.variant);
    if (!selectedVariantId) return;
    checkVariantAvailability(selectedVariantId);
  }

  // this will check after page load
  function getSelectedVariantIdFromDropdown() {
    const dropdown = document.querySelector('.pdp_variant_selection');
    if (!dropdown) return null;
    const selectedOption = dropdown.options[dropdown.selectedIndex];
    if (!selectedOption) return null;
    const variantId = parseInt(selectedOption.dataset.vid);
    console.log('drop variantId ', variantId)
    checkVariantAvailability(variantId)
  }

  // Check variant stock availability
  function checkVariantAvailability(variantId) {
    const expectedDeliveryDays = document.querySelector('.expected_delivery_days');
    const selectedVariant = window.productVariants.find(
      v => v.id === variantId
    );
    // console.log('selectedVariant ', selectedVariant);

    if (!selectedVariant) return;
    const isPreOrder  = selectedVariant.available && selectedVariant.inventory_quantity <= 0;
    const isInStock   = selectedVariant.available && selectedVariant.inventory_quantity > 0;
    if(!selectedVariant.available) {
      const checktAvailable = window.productVariants.find(
        v => v.available && v.inventory_quantity > 0
      );
      if (checktAvailable) {
        showAlternateAvailableOption(checktAvailable);
      }
    }

    if (isPreOrder) {
      productNotes.classList.remove('hidden');
      preOrderNote.classList.remove('hidden');
      setTimeout(() => {
        ATCBtnText.innerHTML = selectedVariant.pre_order;
      }, 200);
      
      if (expectedDeliveryDays) {
        expectedDeliveryDays.classList.remove('hidden');
        calculateDeliveryDate(expectedDeliveryDays, selectedVariant);
      }

      const firstAvailable = window.productVariants.find(
        v => v.available && v.inventory_quantity > 0
      );
      if (firstAvailable) {
        showAlternateAvailableOption(firstAvailable);
      } else {
        showAlternate.innerHTML = 'All variants are out of stock';
        showAlternate.classList.remove('hidden');
      }
    } else if (isInStock) {
      productNotes.classList.add('hidden');
      showAlternate.classList.add('hidden');
      showAlternate.innerHTML = '';
      preOrderNote.classList.add('hidden');
      ATCBtnText.innerHTML = selectedVariant.in_stock;
      if (expectedDeliveryDays) {
        expectedDeliveryDays.classList.add('hidden');
        expectedDeliveryDays.innerHTML = '';
      }
    }
  }

  function showAlternateAvailableOption(firstAvailable) {
    showAlternate.classList.remove('hidden');
    showAlternate.innerHTML = firstAvailable.title + ' is available';
  }

  // calculate and show expected delivery date using metafield
  function calculateDeliveryDate(expectedDeliveryDays, selectedVariant) {
    if (selectedVariant.metafields?.delivery_days) {
      const deliveryDays = parseInt(selectedVariant.metafields.delivery_days);
      const today = new Date();
      today.setDate(today.getDate() + deliveryDays);
      const formattedDate = today.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: '2-digit'
      });
      expectedDeliveryDays.innerHTML =
        `Expected shipping date: ${formattedDate}`;
    }
  }
});




// menu hover effect for new theme update
setTimeout(function () {

  function toggleMegaMenu(subMenu) {
    // Remove active from all menu items
    document.querySelectorAll(".mega_menu_blocks.menu_style01 .mega_sub_menu_name")
      .forEach(function (item) {
        item.classList.remove("active");
      });

    // Add active to current menu
    subMenu.classList.add("active");

    // Get data-menu-name
    const menuName = subMenu.dataset.menuName;

    // Hide all product containers
    document.querySelectorAll(".mega-menu-products_sub").forEach(function (item) {
      item.classList.remove("active");
      item.style.display = "none";
    });

    // Find matching product container
    const target = document.querySelector(`.mega-menu-products_sub[data-name="${menuName}"]`);

    if (target) {
      target.classList.add("active");
      target.style.display = "block";
    }
  }

  // Hover
  document.addEventListener("mouseover", function (event) {
    const subMenu = event.target.closest(".mega_menu_blocks.menu_style01 .mega_sub_menu_name");

    if (!subMenu) return;

    //setTimeout(() => {
      toggleMegaMenu(subMenu);
    //}, 1000);
  });

}, 2000);


